<template>
  <div class="property_wrap">
    <div class="pro_top">联系方式设置</div>
    <div class="pro_con">
      <el-form ref="form" label-width="80px">
        <el-form-item label="组件标题:">
          <el-input v-model="property.label" maxlength="10" show-word-limit></el-input>
        </el-form-item>
      </el-form>
      <div style="width: 100%;margin-bottom:30px;">
        <div id="container" style="width:100%;height:500px;">
          <div class="containerMap"><img src="/static/img/centerAdress.png" alt=""></div>
        </div>
      </div>
      <el-form ref="form" label-width="80px">
        <el-form-item label="公司名称:">
          <el-input v-model="property.name"></el-input>
        </el-form-item>
        <el-form-item label="详细地址:">
          <el-input v-model="property.address" @blur="filterkeyword">
            <!-- <el-button slot="append" @click="filterkeyword" class="aganAdress">确定坐标</el-button> -->
          </el-input>
        </el-form-item>
        <el-form-item label="电话:">
          <el-input v-model="property.mobile" maxlength="20"></el-input>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>
<script>
  // import {BaiduMap, BmNavigation, BmView, BmGeolocation, BmCityList} from 'vue-baidu-map'

  export default {
    props: ["property"],
    components: {},
    data() {
      return {
        form: {},
        mapSearchType: 1, // 1 逆解析 2 地址解析
        mapInfo: {
          longitude: Number(localStorage.getItem("location").split(",")[0]),//经度
          latitude: Number(localStorage.getItem("location").split(",")[1]),//纬度
          city: '',
          zoom: 17,
          map: null, // 初始化地图
          geocoder: null, // 地址搜索
          marker: null // 标注提示
        }
      };
    },
    methods: {
      //定位获得当前位置信息
      getMyLocation() {
        if (!this.form.lat) {
          // var geolocation = new qq.maps.Geolocation("H35BZ-I4VK4-2HEUM-DFSYF-XWEDK-MAF6M", "名片地图地址");
          // geolocation.getIpLocation(this.showPosition, this.showErr);
          this.init();
        } else {
          this.mapInfo.latitude = this.form.lng;
          this.mapInfo.longitude = this.form.lat;
          this.init();
        }
      },
      //成功获取地址
      showPosition(position) {
        this.mapInfo.latitude = position.lng;
        this.mapInfo.longitude = position.lat;
        this.init();
      },
      // 获取地址失败
      showErr() {
        this.getMyLocation();//定位失败再请求定位，测试使用
      },
      init() {
        //步骤：定义map变量 调用 qq.maps.Map() 构造函数 获取地图显示容器
        // 设置地图中心点
        let this_ = this;
        let myLatlng = new qq.maps.LatLng(this.mapInfo.longitude, this.mapInfo.latitude); //定义工厂模式函数
        let myOptions = {
          zoom: this.mapInfo.zoom, //设置地图缩放级别
          center: myLatlng, //设置中心点样式
          mapTypeControl: false,
          panControl: false,
          zoomControl: false
        }
        // 获取dom元素添加地图信息
        this.mapInfo.map = new qq.maps.Map(document.getElementById("container"), myOptions);
        //给定位的位置添加图片标注
        this.mapInfo.marker = new qq.maps.Marker({
          position: myLatlng,
          map: this.mapInfo.map
        });
        // let anchor = new qq.maps.Point(0, 39);
        let size = new qq.maps.Size(40, 40);
        let origin = new qq.maps.Point(0, 0);
        let icon = new qq.maps.MarkerImage(
            "/static/img/adressMap.png",
            size,
            origin
        );
        this.mapInfo.marker.setIcon(icon);

        this.mapInfo.geocoder = new qq.maps.Geocoder({
          complete: function (result) {
            if (this_.mapSearchType === 2) {
              this_.LatLngMap(result.detail.location.lat, result.detail.location.lng);
              let location = [result.detail.location.lat, result.detail.location.lng];
              localStorage.setItem("location", location.join(","));
            } else {
              this_.form.address = result.detail.address
            }
          }
        });

        //当地图中心属性更改时触发事件
        qq.maps.event.addListener(this_.mapInfo.map, 'center_changed', function () {
          this_.mapInfo.latitude = this_.mapInfo.map.getCenter().lat;
          this_.mapInfo.longitude = this_.mapInfo.map.getCenter().lng;
        });
        // 拖动停止
        qq.maps.event.addListener(this_.mapInfo.map, 'dragend', function () {
          this_.mapSearchType = 1;
          this_.LatLngMap(this_.mapInfo.latitude, this_.mapInfo.longitude)
        });
      },
      LatLngMap(lat, lng) {
        this.form.lat = lat;
        this.form.lng = lng;
        let latLng = new qq.maps.LatLng(lat, lng);
        let this_ = this;
        if (this.mapSearchType === 2) {
          let myOptions = {
            zoom: this.mapInfo.zoom, //设置地图缩放级别
            center: latLng, //设置中心点样式
            mapTypeControl: false,
            panControl: false,
            zoomControl: false
          }
          // 获取dom元素添加地图信息
          this.mapInfo.map = new qq.maps.Map(document.getElementById("container"), myOptions);
        }
        this.mapInfo.marker.setMap(null);
        this.mapInfo.marker = new qq.maps.Marker({
          position: latLng,
          map: this_.mapInfo.map
        });
        let size = new qq.maps.Size(40, 40);
        let origin = new qq.maps.Point(0, 0);
        let icon = new qq.maps.MarkerImage(
            "/static/img/adressMap.png",
            size,
            origin
        );
        this.mapInfo.marker.setIcon(icon);
        if (this.mapSearchType === 1) {
          this.mapInfo.geocoder.getAddress(latLng);
        }
      },
      findlocation() {
        this.$emit("findlocdata", this.locData)
        this.mapVisible = false
      },
      mapShow() {
        this.mapVisible = true
      },
      filterkeyword() {
        console.log(this.form.address)
        this.mapSearchType = 2; // 1 逆解析 2 地址解析
        if (this.form.address) {
          this.mapInfo.geocoder.getLocation(this.form.address);
        } else {
          var geolocation = new qq.maps.Geolocation("BN7BZ-EA3WW-BSVR6-RZ26N-27YAZ-NGBDW", "名片地图地址");
          geolocation.getIpLocation(this.showPosition, this.showErr);
        }
      }
    },
    watch: {
      // 因为不能直接修改 props 里的属性，所以不能直接把 formData 通过v-model进行绑定
      // 在这里我们需要监听 formData，当它发生变化时，立即将值赋给 data 里的 form
      property: {
        immediate: true,
        handler(val) {
          this.form = val
        }
      }
    },
    mounted() {
      // props 是单向数据流，通过触发 update 事件绑定 formData，
      // 将 data 里的 form 指向父组件通过 formData 绑定的那个对象
      // 父组件在绑定 formData 的时候，需要加上 .sync
      this.$emit('update:property', this.form);
      // this.init()
      this.getMyLocation()
    }
  };
</script>

